/**
 * Sort keys supported by the Rust option finder's search sorter
 * (`VALID_SORT_KEYS` in option_finder/src/finder/option_search.rs), which rejects
 * any other key. The sorter also accepts aliases such as `probabilityOTM` for
 * `probabilityOtm`; stored configs use the spellings listed here. Sort keys are
 * request inputs: the finder's response field is `probabilityOTM`
 * (`optionFinderOptionSchema`).
 */
export const OPTION_SEARCH_SORT_KEYS = [
    'strike',
    'bidPrice',
    'askPrice',
    'mid',
    'last',
    'daysToExpiration',
    'impliedVolatility',
    'premiumArorc',
    'putSellScore',
    'probabilityOtm',
    'percentageOTM',
    'percentageITM',
    'volume',
    'bidSize',
    'askSize',
    'openInterest'
];
//# sourceMappingURL=OptionSearch.js.map